import { AxiosError } from 'axios';
import axiosClient from '../axiosClient';
import { PUT_NON_NATIONAL_EXAM_WITHDRAWAL_CONFIRM_WITHDRAWAL_URL } from '../../constants/apiUrls';
import { useCustomMutation } from '../utils/useCustomMutation';
import { GenericErrorResponse } from '../typings';

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  uuid: string;
  onSuccess?: () => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const usePutNonNationalConfirmWithdrawal = ({ uuid, onSuccess, onError }: Input) => {
  const putNonNationalConfirmWithdrawal = async () => {
    const res = await axiosClient.put<void>(
      PUT_NON_NATIONAL_EXAM_WITHDRAWAL_CONFIRM_WITHDRAWAL_URL(uuid)
    );
    return res.data;
  };

  return useCustomMutation(putNonNationalConfirmWithdrawal, {
    onSuccess,
    onError,
  });
};
